import {
  Box,
  Button,
  Image,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Stack,
  Text,
  Tooltip,
  useColorModeValue,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { trunc } from "../../../utils";
import { checkout, joinGroup } from "./service";
import { useState } from "react";
import { photoBaseURL } from "../../../service/api";
import { errorNotifier, successNotifier } from "../../..";
import { loadStripe } from "@stripe/stripe-js";
import StripeForm from "../../../components/Stripe/StripeForm";
import { useGetState } from "../../../context/useGetState";
import { useEffect } from "react";
import GroupSlideInfo from "./GroupSlideInfo";
const stripe = loadStripe(process.env.REACT_APP_STRIPE_KEY);
function TradingGroupCard({
  group,
  accountType,
  searchText,
  categoryText,
  isSearch,
  isCategory,
}) {
  const modeBg = useColorModeValue("#fff", "#030c1b");
  const modeBoxShadow = useColorModeValue("#80808024", "#030c1b");
  const [showPaymentForm, setShowPaymentForm] = useState(false);
  const { state } = useGetState();
  const [loading, setLoading] = useState(false);
  const [clientSecret, setClientSecret] = useState("");
  const [updatedGroup, setUpdatedGroup] = useState(group);
  const [isSlideOutVisible, setIsSlideOutVisible] = useState(false);
  const [groupSlideInfoModalOpen, setGroupSlideInfoModalOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  const navigate = useNavigate();

  const fadeIn = {
    display: "block",
  };

  const fadeOut = {
    display: "none",
  };
  const handleSubmit = async (groupType) => {
    if (groupType === "paid") {
      setGroupSlideInfoModalOpen(true);
    } else {
      setLoading(true);
      await joinGroup(group?.invite_link)
        .then((data) => {
          setLoading(false);
          setUpdatedGroup(data?.data);
          successNotifier(`Successfully joined ${data?.data?.name} group`);
          navigate("/all-groups");
        })
        .catch((e) => {
          const notSubscribed = e?.response?.data?.errors?.no_subscription;
          const expiedSubscription =
            e?.response?.data?.errors?.subscription_expired;
          const trialPeriodOver = e?.response?.data?.errors?.trial_period_over;
          setLoading(false);
          if (notSubscribed || expiedSubscription || trialPeriodOver) {
            let accountType = state?.userInfo?.account_type;
            checkout(accountType, group?.id)
              .then((res) => {
                let clientSecret = res?.data?.client_secret;
                errorNotifier(`${e?.response?.data?.message}...`);

                setClientSecret(clientSecret);
                setShowPaymentForm(true);
              })
              .catch((res) => errorNotifier(res?.response?.data?.message));
          } else {
            errorNotifier(`${e?.response?.data?.message}`);
          }
        });
    }
  };

  let isTextMatching = searchText
    ? group?.name?.toLowerCase().includes(searchText.toLowerCase())
    : group?.category?.name?.toLowerCase().includes(categoryText.toLowerCase());
  useEffect(() => {}, [searchText, categoryText, updatedGroup]);

  const handleTagClick = () => {
    setIsSlideOutVisible(!isSlideOutVisible);
  };

  return (
    <Stack
      style={isTextMatching ? fadeIn : fadeOut}
      maxW={"180px"}
      w="180px"
      borderRadius="20px"
      boxShadow={`2px 2px 14px 0px ${modeBoxShadow}`}
      p="7px"
      bg={modeBg}
      cursor={"pointer"}
      onClick={() => setGroupSlideInfoModalOpen(true)}
    >
      <Box
        position={"relative"}
        display="flex"
        justifyContent={"center"}
        alignItems="center"
      >
        <Image
          boxShadow={`2px 2px 14px 0px ${modeBoxShadow}`}
          borderRadius={"20px"}
          w="100%"
          h="120px"
          objectFit={"cover"}
          alt="random user pic"
          fallbackSrc="https://via.placeholder.com/150"
          src={updatedGroup?.picture}
        />
      </Box>
      <Stack alignItems="flex-start" px="3px">
        <Text fontWeight={"bold"} fontSize=".9em" className="groupName">
          {trunc(updatedGroup?.name, 20)}
        </Text>
        <Tooltip label={updatedGroup?.description} aria-label="A tooltip">
          <Text fontSize={".63em"} pb="10px" textAlign={"left"}>
            {trunc(updatedGroup?.description, 30)}
          </Text>
        </Tooltip>
      </Stack>
      <Stack
        justifyContent={"space-between"}
        direction="row"
        alignItems={"center"}
        mb="5px !important"
      >
        {updatedGroup?.is_member ? (
          <Button
            size="xs"
            h="20px"
            w="70px"
            bg="#2d3748"
            _hover={{ background: "#2d3748" }}
            color="#fff"
            boxShadow={"2px 2px 7px 0px #2d3748"}
            cursor={"default"}
          >
            Member
          </Button>
        ) : (
          <Button
            size="xs"
            h="20px"
            w="70px"
            bg="#7CD892"
            _hover={{ background: "#7CD892" }}
            color="#fff"
            boxShadow={"2px 2px 7px 0px #7cd892b3"}
            isLoading={loading}
          >
            Join
          </Button>
        )}
        <Text color="#4F46BA" fontSize={".8em"} fontWeight="600">
          {updatedGroup?.type == "paid" ? "Paid" : "Free"}
        </Text>
      </Stack>

      <GroupSlideInfo
        groupData={updatedGroup}
        handleSubmit={handleSubmit}
        isOpen={groupSlideInfoModalOpen}
        onClose={() => setGroupSlideInfoModalOpen(false)}
      />
    </Stack>
  );
}

export default TradingGroupCard;
